import {
	Component,
	Output,
	EventEmitter,
	Input,
	Renderer2,
	ElementRef,
	OnInit,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../../globals/classes/base.component';
import { ICardLoginRequest } from '../../classes/existing-onboarding-customer/requests';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'card-info',
	template: require('./card-info.component.html'),
})
export class CardInfoComponent extends BaseComponent implements OnInit {
	acceptedCards: boolean = false;
	card: string = '';
	numbers: number[] = [0, 1, 2, 3];
	pins: number[] = [null, null, null, null];
	check: boolean[] = [false, false, false, false];
	public isRebrading = AppSettings.isRebrading;

	private readonly validCardNumberRegex = /^\d{16}$/;
	private readonly validCardPINRegex = /^\d{4}$/;
	private readonly validOnlyNumberRegex = /^[0-9]+$/;

	@Input() cardLoginRequest: ICardLoginRequest;
	@Input() invalidCredentials$: Observable<boolean>;
	@Output() isValid = new EventEmitter<boolean>();

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private renderer: Renderer2,
		private elementRef: ElementRef
	) {
		super();
	}

	public ngOnInit(): void {
		this.mortalize(this.invalidCredentials$)
			.pipe(filter((value) => value === true))
			.subscribe(() => {
				this.pins = [null, null, null, null];
				const updatedPin = this.convertArrayToString(this.pins);
				this.cardLoginRequest.cardPIN = updatedPin;
				const isFormValid = this.isFormValid(this.card, updatedPin);
				this.isValid.emit(isFormValid);
			});
	}

	closeModal(): void {
		this.activeModal.close();
	}

	toggleAcceptedCards() {
		this.acceptedCards = !this.acceptedCards;
	}
	public changeType(index: number): string {
		if (!this.check[index]) {
			return '';
		} else {
			return 'password';
		}
	}

	public fetchBackspaceKeyInputElem(event: KeyboardEvent, index: number) {
		if (event.code === 'Backspace' && index > 0 && this.pins[index] == null) {
			var prevPinInputElem = this.fetchHtmlPinInput(index - 1);
			if (!!prevPinInputElem) prevPinInputElem.focus();
		}
	}
	public showCardPinInputElem(event: KeyboardEvent, index: number) {
		setTimeout(() => {
			if (this.pins[index] !== null || this.pins[index] !== undefined) {
				this.check[index] = true;
			} else {
				this.check[index] = false;
			}
		}, 500);
	}

	public cardInputUpdated(cardNumber: string): void {
		this.cardLoginRequest.cardNumber = cardNumber;
		const isFormValid = this.isFormValid(cardNumber, this.convertArrayToString(this.pins));
		this.isValid.emit(isFormValid);
	}
	public cardInputFilled(event: KeyboardEvent) {
		const target = <HTMLInputElement>event.target;
		if (!this.isValidCardOnlyNumber(target.value)) {
			target.value = this.removeInvalidCardCharacters(target.value);
			return;
		}
	}

	public pinInputFilled(event: KeyboardEvent, index: number) {
		const target = <HTMLInputElement>event.target;
		if (target.value.length == 2) {
			target.value = target.value[0];
			return;
		}

		if (!this.isValidPinDigit(target.value)) {
			this.pins[index] = null;
			target.value = null;
			this.check[index] = false;
		}

		const nextPinInputHtml = this.fetchHtmlPinInput(index + 1);
		if (!!nextPinInputHtml && this.pins[index] != null) nextPinInputHtml.focus();
	}

	public pinInputUpdated(event: KeyboardEvent, value: string): void {
		if (!this.isValidPinDigit(value) && event.code != 'Backspace') {
			return;
		}

		const updatedPin = this.convertArrayToString(this.pins);
		this.cardLoginRequest.cardPIN = updatedPin;
		const isFormValid = this.isFormValid(this.card, updatedPin);
		this.isValid.emit(isFormValid);
	}

	private removeInvalidCardCharacters(value: string): string {
		const newValue = value.replace(/[^\d]/g, '');
		return newValue;
	}

	private fetchHtmlPinInput(index: number): HTMLInputElement {
		if (index < 0 || index >= this.pins.length) return;

		var elemContainer = <NodeList>(
			this.elementRef.nativeElement.querySelectorAll('.small-number-container')
		);

		var item = elemContainer.item(index) as HTMLInputElement;
		return item.firstChild as HTMLInputElement;
	}

	private isValidPinDigit(value: string): boolean {
		const valueAsNumber = Number.parseInt(value);
		if (isNaN(valueAsNumber) || valueAsNumber < 0 || valueAsNumber > 9) {
			return false;
		} else {
			return true;
		}
	}

	private convertArrayToString(numbers: number[]): string {
		var result = '';
		for (let i = 0; i < numbers.length; i++) {
			var slot = numbers[i];
			if (slot != null) {
				result += slot.toString();
			}
		}
		return result;
	}

	private isFormValid(cardNumber: string, cardPin: string): boolean {
		return this.isValidCardNumner(cardNumber) && this.isValidPin(cardPin);
	}

	private isValidCardNumner(card: string): boolean {
		var isValid = this.validCardNumberRegex.test(card);
		return isValid;
	}
	private isValidCardOnlyNumber(card: string): boolean {
		var isValid = this.validOnlyNumberRegex.test(card);
		return isValid;
	}

	private isValidPin(pin: string): boolean {
		var isValid = this.validCardPINRegex.test(pin);
		return isValid;
	}
}
